<template>
  <div>
    <banner-component title="Contact et demande de devis" :lead="lead" :breadcrumbs="breadcrumbs" ruled/>

    <section class="band" aria-labelledby="ways-title">
      <div class="container columns-2">
        <div>
          <h2 id="ways-title">Nous joindre</h2>
          <ul class="ways">
            <li>
              <img src="/img/mail.png" width="40" height="40" alt="" loading="lazy">
              <div>
                <p class="what">Par e-mail</p>
                <a :href="'mailto:' + site.email">{{ site.email }}</a>
              </div>
            </li>
            <li>
              <img src="/img/phone.svg" width="40" height="40" alt="" loading="lazy">
              <div>
                <p class="what">Par téléphone</p>
                <a :href="'tel:' + site.phoneIntl">{{ site.phone }}</a>
              </div>
            </li>
            <li>
              <img src="/img/linkedin.png" width="40" height="40" alt="" loading="lazy">
              <div>
                <p class="what">Sur LinkedIn</p>
                <a :href="site.linkedin" rel="noopener me">Franck Besson</a>
              </div>
            </li>
          </ul>
        </div>

        <div class="brief">
          <h2>Pour gagner du temps</h2>
          <p>Quelques lignes suffisent pour que la première réponse soit précise.</p>
          <h3>Un site vitrine</h3>
          <ul>
            <li>Votre activité et vos clients</li>
            <li>Les pages souhaitées, ou l'adresse de votre site actuel</li>
            <li>Une date de mise en ligne, si vous en avez une</li>
          </ul>
          <h3>Un logiciel ou une application</h3>
          <ul>
            <li>Le problème à résoudre ou la fonction à ajouter</li>
            <li>Les technologies déjà en place</li>
          </ul>
          <h3>Le Gestionnaire Citron</h3>
          <ul>
            <li>Votre question, votre métier et la taille de votre équipe</li>
          </ul>
        </div>
      </div>
    </section>

    <section class="band band--white" aria-labelledby="more-title">
      <div class="container">
        <h2 id="more-title">Avant d'écrire</h2>
        <div class="links">
          <router-link to="/gestionnaire-citron">Le Gestionnaire Citron</router-link>
          <router-link to="/site-web">Création de site web</router-link>
          <router-link to="/logiciel">Logiciel sur mesure</router-link>
          <router-link to="/blog">Les guides sur la facturation</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import site from "@/content/site";
  import pages from "@/content/pages";
  import {useSeo} from "@/seo/useSeo";
  import {organization, person, webPage, breadcrumb, absoluteUrl} from "@/seo/schema";
  import BannerComponent from "@/components/BannerComponent.vue";

  const PATH = '/contact';

  const BREADCRUMBS = [
    {name: 'Accueil', path: '/'},
    {name: 'Contact', path: PATH}
  ];

  export default {
    name: 'ContactView',
    components: {BannerComponent},
    setup() {
      const page = pages.find(entry => entry.path === PATH);
      useSeo({
        path: PATH,
        graph: [
          organization(),
          person(),
          webPage(PATH, page.title, page.description, {
            '@type': 'ContactPage',
            breadcrumb: {'@id': `${absoluteUrl(PATH)}#breadcrumb`}
          }),
          {...breadcrumb(BREADCRUMBS), '@id': `${absoluteUrl(PATH)}#breadcrumb`}
        ]
      });
    },
    data: function () {
      return {
        site,
        breadcrumbs: BREADCRUMBS,
        lead: 'Une question sur le Gestionnaire Citron, un projet de site ou un logiciel à faire évoluer ? Écrivez ou appelez, vous parlez directement à Franck Besson.',
      }
    }
  }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

.columns-2
  display grid
  gap 48px
  align-items start

.ways
  list-style none
  margin 24px 0 0
  padding 0
  border-top 2px solid INK
  li
    display flex
    align-items center
    gap 18px
    margin 0
    padding 18px 0
    border-bottom 1px solid RULE
  img
    flex none
    width 40px
    height 40px
    object-fit contain
  .what
    margin 0
    color MUTED
    font-size 0.92rem
  a
    font-size 1.2rem
    font-weight 650

.brief
  padding 24px
  background WHITE
  border 1px solid RULE
  border-top 4px solid LEMON
  border-radius 4px
  h2
    margin 0 0 8px
    font-size 1.5rem
  p
    margin 0 0 8px
    color INK_SOFT
  h3
    margin 18px 0 4px
    font-size 1.1rem
    font-family inherit
    font-weight 700
  ul
    margin 0
    padding-left 1.2em
  li
    margin-top 3px
    color INK_SOFT
    &::marker
      color LEMON_DEEP

.links
  display flex
  flex-wrap wrap
  gap 12px 28px
  margin-top 20px

@media (min-width: DESKTOP_SIZE)
  .columns-2
    grid-template-columns 1fr 1fr
    gap 72px
</style>
